import { render } from "./GameDetailView.vue?vue&type=template&id=4b5aff60&scoped=true"
import script from "./GameDetailView.vue?vue&type=script&lang=js"
export * from "./GameDetailView.vue?vue&type=script&lang=js"

import "./GameDetailView.vue?vue&type=style&index=0&id=4b5aff60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5aff60"]])

export default __exports__